import { Input, LoadingButton } from "components/form";
import React, { useRef, useState } from "react";
import { toast } from "react-toastify";
import {
  downloadBulkOrderSampleAPI,
  uploadBulkOrderAPI,
} from "services/user-controllers/bulk-order-controller";

const BulkOrder = () => {
  //************************ Handle all state ***********************//
  const fileInputRef = useRef(null);

  const [bulkOrderFileValue, setBulkOrderFileValue] = useState();
  const [downloadSampleButtonLoading, setDownloadSampleButtonLoading] =
    useState(false);
  const [uploadSampleButtonLoading, setUploadSampleButtonLoading] =
    useState(false);

  //*********************** Handle all function **********************//

  // onChangeHandler
  const onChangeHandler = (e) => {
    const fileInput = e?.target?.files[0];
    setBulkOrderFileValue(fileInput);
  };

  // Function for download bulk order sample file
  const downloadBulkOrderFileHandler = async () => {
    try {
      setDownloadSampleButtonLoading(true);
      const response = await downloadBulkOrderSampleAPI();
      const { data, headers } = response;
      if (response.status !== 200) {
        return toast.error("Failed to download the file.");
      }
      // Create a blob from the response data
      const blob = new Blob([data], { type: headers["content-type"] });

      // Create a link element to download the file
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);

      // Set the download attribute with a filename
      const filename =
        headers["content-disposition"]?.split("filename=")[1] ||
        "bulk-order-sample.xlsx";
      link.download = filename.replace(/"/g, "");

      // Append, click to trigger the download, then remove
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      console.error(err);
      toast.error("Error occurred while downloading the file.");
    } finally {
      setDownloadSampleButtonLoading(false);
    }
  };

  // Function for upload bulk order sheet
  const uploadBulkOrderSampleHandler = async (e) => {
    e.preventDefault();
    if (!bulkOrderFileValue) {
      return toast.error("Please select a file to upload.");
    }
    const formData = new FormData();
    formData.append("excelSheet", bulkOrderFileValue);

    try {
      setUploadSampleButtonLoading(true);
      const { data } = await uploadBulkOrderAPI(formData);
      if (data.code === 200) {
        setBulkOrderFileValue();
        toast.success(data?.message);
      } else {
        toast.error(data?.message);
        console.error(data?.message);
      }
    } catch (err) {
      console.error(err);
      toast.error("Error occurred while uploading the file.");
    } finally {
      setUploadSampleButtonLoading(false);
    }
  };

  //************************ Handle HTML CODE ***********************//

  return (
    <div className="_inner_content wrap_cstm_bulkorder">
      <div className="page_title">
        <h3>Upload Bulk Orders</h3>
      </div>
      <div className="wrapper_upload_file">
        <div className="wrap_file">
          <div className="file_upload">
            <div
              className="card_bg"
              onClick={() => fileInputRef?.current?.click()}
            >
              <p>
                {!bulkOrderFileValue?.name ? (
                  <b>Upload Bulk Order Files</b>
                ) : (
                  <b>{bulkOrderFileValue?.name || "-----"}</b>
                )}
              </p>
              <span>Upload the filled .xlsx file. Max 10MB</span>

              <Input
                type="file"
                ref={fileInputRef}
                onChange={onChangeHandler}
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              />
            </div>
          </div>
          <div className="txt">
            <p>
              Effortlessly streamline your workflow - simply upload your bulk
              orders file for swift and efficient processing. The format of the
              file is fixed and you can download it from the download button.
              Download it, fill in the data and then upload it here. The vendor,
              service and rate are picked automatically from your account.
            </p>

            <LoadingButton
              loading={uploadSampleButtonLoading}
              disabled={uploadSampleButtonLoading}
              onClick={uploadBulkOrderSampleHandler}
              className={uploadSampleButtonLoading ? "disabled" : ""}
            >
              Upload
            </LoadingButton>
          </div>
        </div>
        <div className="wrap_btn">
          <LoadingButton
            loading={downloadSampleButtonLoading}
            disabled={downloadSampleButtonLoading}
            onClick={downloadBulkOrderFileHandler}
            className={downloadSampleButtonLoading ? "disabled" : ""}
          >
            Download Excel Sample Data File
          </LoadingButton>
        </div>
      </div>
    </div>
  );
};

export default BulkOrder;
